import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import Pagination from "react-js-pagination";
import DuNoGiaoNhanVienApi from "service/duNoGiaoNhanVien";
import { formatNumber } from "utils/currencyFormat";
import { getDate } from "utils/formatDate";
import { BtnChiTietHopDong } from "./ChiTietHopDong/BtnChiTietHopDong";
import { BtnChiTietKhachhang } from "./ChiTietKhachHang/BtnChiTietKhachhang";
export const ModalChiTietSoNo = (props) => {
  useEffect(() => {
    DanhSachChiTiet(1);
  }, []);

  const dataInit = {
    List: [],
    TongDuNo: 0,
    TongBanGhi: 0,
  };
  const [dataChiTiet, UpdateDataChiTiet] = useState(dataInit);
  const [pageIndex, setPageIndex] = useState(1);
  const DanhSachChiTiet = (page) => {
    DuNoGiaoNhanVienApi.getListChiTietDuNo(props.userId, page, 20).then(
      (response) => {
        UpdateDataChiTiet({
          ...dataChiTiet,
          List: response.data.List,
          TongDuNo: response.data.TongDuNo,
          TongBanGhi: response.data.TongBanGhi,
        });
      }
    );
  };

  const PhanTrang = (index) => {
    setPageIndex(index);
    DanhSachChiTiet(index);
  };

  const listItem = () => {
    return (
      dataChiTiet.List != null &&
      dataChiTiet.List.map((item, index) => {
        return (
          <tr>
            <th scope="row">{index + 1 + (pageIndex - 1) * 20}</th>
            <td>
              <BtnChiTietHopDong item={item} />
            </td>
            <td>
              <BtnChiTietKhachhang item={item} />
            </td>
            <td>{getDate(item.NgayVay)}</td>
            <td>{getDate(item.NgayTra)}</td>
            <td className="text-right">
              <span className="color-do">
                {formatNumber(item.SoTienVayConLai)}
              </span>
            </td>
          </tr>
        );
      })
    );
  };

  return (
    <Modal
      {...props}
      size="modal-xl modal-xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left popup-detail"
    >
      <Modal.Header>
        <h4 className="modal-title  color7-bold" id="myModalLabel16">
          <span className="btn-icon-right">
            <i className="mdi mdi-bookmark-multiple-outline"></i>
          </span>
          Số dư nợ
        </h4>
        <button
          type="button"
          className="close-popup-new"
          onClick={props.onHide}
        >
          <img src="/app-assets/images/icon-dong-popup-v2.png" />
        </button>
      </Modal.Header>
      <Modal.Body>
        <form className="form tat-toan form-horizontal">
          <div className="form-body">
            <div className="card collapse-icon accordion-icon-rotate">
              <div
                id="headingCollapse253128"
                className="card-header border-info"
                href="#collapse253128"
                aria-expanded="true"
                aria-controls="collapse25312"
              >
                <a className="card-title lead info collapsed">
                  <h3>Chi tiết dư nợ của: {props.FirstName} Quản lý</h3>
                </a>
              </div>
              <div
                id="collapse2531288"
                role="tabpanel"
                aria-labelledby="headingCollapse253128"
                className="card-collapse collapse show"
                aria-expanded="true"
              >
                <div className="card-content">
                  <div className="card-body">
                    <div className="Left-table">
                      <div className="table-responsive table-1">
                        <table className="table table-bordered mb-0 table-hover">
                          <thead>
                            <tr>
                              <th>
                                STT
                                <br />{" "}
                                <span className="red">
                                  [ {dataChiTiet.TongBanGhi} ]
                                </span>
                              </th>
                              <th>Mã cho vay</th>
                              <th>Tên khách hàng</th>
                              <th>Ngày vay</th>
                              <th>Ngày trả</th>
                              <th className="text-right">
                                Số dư nợ
                                <br />{" "}
                                <span className="color-do">
                                  {formatNumber(dataChiTiet.TongDuNo)}
                                </span>
                              </th>
                            </tr>
                          </thead>
                          <tbody>{listItem()}</tbody>
                        </table>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: " center",
                            marginTop: "10px",
                          }}
                        >
                          <Pagination
                            activePage={pageIndex}
                            itemsCountPerPage={20}
                            totalItemsCount={dataChiTiet.TongBanGhi}
                            pageRangeDisplayed={5}
                            onChange={PhanTrang}
                            itemClass="page-item"
                            linkClass="page-link"
                            activeClass="active"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer className="modal-footer button-popup-new-size">
        <a
          className="btn btn-new-main btn-closenew"
          data-dismiss="modal"
          href={() => false}
          onClick={props.onHide}
        >
          <span className="btn-icon-left">
            <i className="mdi mdi-close"></i>
          </span>
          Đóng
        </a>
      </Modal.Footer>
    </Modal>
  );
};
